import { default as general, namespace as generalNamespace } from './modules/general'

const namespaced = true
const namespace = 'SocialNotifications'

const modules = {
    [generalNamespace]: general,
}

export {namespaced, namespace, modules}
